import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName App Stroke
 */

export default function AppStrokeIcon(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <path
        clipRule="evenodd"
        d="M2 3C0.895431 3 0 3.89543 0 5V11C0 12.1046 0.895431 13 2 13H14C15.1046 13 16 12.1046 16 11V5C16 3.89543 15.1046 3 14 3H2ZM2 4C1.44772 4 1 4.44772 1 5V11C1 11.5523 1.44772 12 2 12H14C14.5523 12 15 11.5523 15 11V5C15 4.44772 14.5523 4 14 4H2ZM3.32635 9.00497L3.00249 10H2.01385L3.52024 5.63636H4.70916L6.21342 10H5.22479L4.90092 9.00497H3.32635ZM4.09766 6.63352L3.56072 8.2848H4.66868L4.13175 6.63352H4.09766ZM7.66122 10H6.73864V5.63636H8.46023C9.45099 5.63636 10.0241 6.24787 10.0241 7.11506C10.0241 7.98651 9.44034 8.58523 8.43679 8.58523H7.66122V10ZM7.66122 6.39062V7.84588H8.28764C8.81605 7.84588 9.07386 7.54759 9.07386 7.11506C9.07386 6.6804 8.81605 6.39062 8.28338 6.39062H7.66122ZM11.546 10H10.6234V5.63636H12.345C13.3358 5.63636 13.9089 6.24787 13.9089 7.11506C13.9089 7.98651 13.3251 8.58523 12.3216 8.58523H11.546V10ZM11.546 6.39062V7.84588H12.1724C12.7008 7.84588 12.9586 7.54759 12.9586 7.11506C12.9586 6.6804 12.7008 6.39062 12.1681 6.39062H11.546Z"
        fillRule="evenodd"
      />
    </Icon>
  );
}
